export default {
    getResponsivePrompts: function() {
        return this.promptWidgets.map(function(widget) {
            var size = widget.wrapper[0].getBoundingClientRect();
            return {
                model: widget.options.model,
                inputType: widget.options.model.inputType,
                labelPosition: widget.options.model.labelPosition,
                x: widget.options.model.x,
                y: widget.options.model.y,
                width: size.width,
                height: size.height
            };
        });
    }
}
